import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { DOMAIN_KEYS, getDefaultDomain } from '../../../shared/constants';

/**
 * Ensures the URL always has a valid `?domain=` param before the route activates.
 * Runs BEFORE components initialize, so SearchService sees the correct domain
 * on its very first fetch — no race condition, no double-fetch.
 */
export const domainGuard: CanActivateFn = (route, state) => {
  const domain = route.queryParams['domain'];
  if (domain && DOMAIN_KEYS.indexOf(domain as any) >= 0) {
    return true;
  }
  const router = inject(Router);
  const tree = router.parseUrl(state.url);
  tree.queryParams['domain'] = getDefaultDomain();
  return tree;
};
